import { ToolPageShell } from '@/shared/seo'
import { ExcelVPdfForm } from './ExcelVPdfForm'

export function ExcelVPdfPage() {
  return (
    <ToolPageShell utilityKey="excelVPdf">
      <ExcelVPdfForm />
    </ToolPageShell>
  )
}
